import './persons_treatments';
import './persons_treatments-list';
import './persons_treatments-edit';